import React from "react";
import {
  Segment,
  Table,
  Label
  //Grid,
  //Header,
  //Button
} from "semantic-ui-react";

import * as moment from "moment";

export default ({ errMsg, history }) => (
  <Segment>
    <p>{errMsg}</p>
    <p>History of purchased packages</p>
    <Table celled>
      <Table.Body>
        {history.map((hist, i) => (
          <Table.Row key={i}>
            <Table.Cell>
              <Label ribbon style={{ fontSize: 15 }}>
                Purchased
                {" " + hist.pckg + "$"}
              </Label>
            </Table.Cell>
            <Table.Cell>{" " + moment(hist.time).format("LLLL")} </Table.Cell>
            <Table.Cell>
              {"valid up to " +
                moment(moment(hist.time).add(6, "weeks")).format("LLLL")}{" "}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </Segment>
);



// WEBPACK FOOTER //
// ./src/views/UserDash/History.js